import { render, staticRenderFns } from "./PostSidebar.vue?vue&type=template&id=53259e9a&"
import script from "./PostSidebar.vue?vue&type=script&lang=js&"
export * from "./PostSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PostSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports